import { MixpanelEvent, useDynamicCallback, useMixpanel, type Security } from '@talos/kyoko';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_LAYOUT_ID } from '../components/AppLayout/Layouts/tokens';
import type { MultilegComboType } from '../components/MultilegCombo/enums';
import { getNavGroupSlug } from '../components/NavigationSidebar/spacesNavPath';
import { getMultilegDeepDiveRoute } from '../containers/Routes/routes';
import { useAppLayoutConfig } from '../providers/AppLayoutConfig/AppLayoutConfigContext';
import { useCurrentAppLayoutId } from './useAppLayoutId';

export function useNavigateToMultilegCombo() {
  const navigate = useNavigate();
  const mixpanel = useMixpanel();
  const layoutId = useCurrentAppLayoutId() ?? DEFAULT_LAYOUT_ID;
  const { layoutConfigs } = useAppLayoutConfig('trading');
  const navGroupName = useMemo(() => getNavGroupSlug(layoutConfigs, layoutId), [layoutConfigs, layoutId]);

  const navigateToMultilegCombo = useDynamicCallback(
    (
      instrumentType: MultilegComboType,
      security?: Security,
      marketAccountNames?: string[],
      marketNames?: string[],
      legSymbols?: string[]
    ) => {
      mixpanel.track(MixpanelEvent.OpenMultilegDeepDive);
      navigate(
        getMultilegDeepDiveRoute({
          instrumentType,
          symbol: security?.Symbol,
          layoutId,
          navGroupName,
          marketAccountNames,
          marketNames,
          legSymbols,
        })
      );
    }
  );

  return navigateToMultilegCombo;
}
